/**
 * File components/DatetimesInterval.js
 *
 * To manage the selection of an interval of dates
 *
 * Learn more: https://saint-augustin.ch
 */

import React from 'react'
const LOCAL_LANGUAGE = navigator.language.trim().split(/-|_/)[0];

const DatetimesInterval= ({ id, startDatetime, endDatetime, onStartChange, onEndChange }) => {
    
    return (
        <div className="datetime-interval">
			<div className="form-group">
				<label htmlFor={`${id}-start`}>du </label>
				<input
					type="datetime-local"
					id={`${id}-start`}
					className="form-control"
					value={startDatetime}
                    onChange={(e) => onStartChange(e.target.value)}
				/>
			</div>

			<div className="form-group">
				<label htmlFor={`${id}-end`}> au </label>
				<input
					type="datetime-local"
					id={`${id}-end`}
					className="form-control"
					value={endDatetime}
					onChange={(e) => onEndChange(e.target.value)}
				/>
			</div>
        </div>
    );
}

export default DatetimesInterval;